/** @jsx jsx */
import { jsx, css } from '@emotion/core'
import { PureComponent } from 'react'

const Color = css`
  width: inherit;
  height: auto;
  .fill {
    fill: #acacac;
  }
`
export default class PwIco extends PureComponent {
  render() {
    return (
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="12" viewBox="0 0 8 12" css={Color}>
        <g id="그룹_5586" data-name="그룹 5586" transform="translate(-55 -246)">
          <path id="패스_5290" className="fill" data-name="패스 5290" d="M-613.182,488.33h-6.995a.5.5,0,0,0-.5.5v5.95a.5.5,0,0,0,.5.5h6.995a.5.5,0,0,0,.5-.5v-5.95A.5.5,0,0,0-613.182,488.33Zm-3.106,3.84v.77a.131.131,0,0,1-.121.13h-.533a.133.133,0,0,1-.131-.13v-.77a.857.857,0,0,1-.472-.76.869.869,0,0,1,.864-.86.862.862,0,0,1,.864.86A.839.839,0,0,1-616.287,492.17Z" transform="translate(675.679 -237.28)" fill="#acacac"/>
          <path id="패스_5291" className="fill" data-name="패스 5291" d="M-614.186,489.327h-4.982a.5.5,0,0,1-.5-.5v-3.149a2.658,2.658,0,0,1,2.663-2.646h.663a2.658,2.658,0,0,1,2.663,2.646v3.149A.5.5,0,0,1-614.186,489.327Zm-4.479-1h3.976v-2.649a1.653,1.653,0,0,0-1.656-1.646h-.663a1.653,1.653,0,0,0-1.656,1.646Z" transform="translate(675.679 -237.032)" fill="#acacac"/>
        </g>
      </svg>
    )
  }
}
